import { Toaster as Sonner, ToasterProps } from "sonner"

import { useTheme } from "@/components/ThemeProvider"

/**
 * Canonical app-wide toast surface.
 *
 * Single source of the toast language: neutral `--dash-*` surface, bottom-right
 * placement, no `richColors` (semantic meaning is a 3px left rail + icon tint,
 * applied via the `[data-sonner-toast][data-type=…]` rules in index.css — NOT a
 * full colored fill). Mount exactly one of these at the app root; per-call
 * helpers in `@/helpers/toast.helpers` share the same tokens.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="bottom-right"
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--dash-surface, var(--popover))",
          "--normal-text": "var(--dash-ink, var(--text-high-emphasis))",
          "--normal-border": "var(--dash-hairline, var(--border))",
          "--border-radius": "13px",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
